export default "__VITE_ASSET__946e3f4f__"